import { render, staticRenderFns } from "./StoryEditorPlot.vue?vue&type=template&id=03284d7f&scoped=true&"
import script from "./StoryEditorPlot.vue?vue&type=script&lang=js&"
export * from "./StoryEditorPlot.vue?vue&type=script&lang=js&"
import style0 from "./StoryEditorPlot.vue?vue&type=style&index=0&id=03284d7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03284d7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
